import * as types from '../actions/action-types';
import moment from 'moment';

const initialState = {
  friends: [],
  fetchingFriends: false,
  fetchedFriends: false,
  errorFetchingFriends: null,

  userSearchResult: [],
  isSearchingUsers: false,
  hasSearchedUsers: false,
  errorSearchingUsers: null,

  addedFriend: null,
  isAddingFriend: false,
  errorAddingFriend: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FRIENDS_REQUEST_LIST_PENDING:
      return {
        ...state,
        fetchingFriends: true,
        errorFetchingFriends: null
      };

    case types.FRIENDS_REQUEST_LIST_FULFILLED:
      return {
        ...state,
        friends: action.payload,
        fetchingFriends: false,
        fetchedFriends: true,
        errorFetchingFriends: null
      };

    case types.FRIENDS_REQUEST_LIST_REJECTED:
      return {
        ...state,
        fetchedFriends: false,
        errorFetchingFriends: action.payload
      };

    case types.FRIENDS_REQUEST_ADD_FRIEND_PENDING:
      return {
        ...state,
        addedFriend: null,
        isAddingFriend: true,
        errorAddingFriend: null
      };

    case types.FRIENDS_REQUEST_ADD_FRIEND_FULFILLED:
      return {
        ...state,
        addedFriend: action.payload,
        isAddingFriend: false,
        errorAddingFriend: null
      };

    case types.FRIENDS_REQUEST_ADD_FRIEND_REJECTED:
      return {
        ...state,
        addedFriend: null,
        isAddingFriend: false,
        errorAddingFriend: action.payload
      };

    case types.FRIENDS_SEARCH_USER_PENDING:
      return {
        ...state,
        isSearchingUsers: true,
        hasSearchedUsers: false,
        errorSearchingUsers: null
      };

    case types.FRIENDS_SEARCH_USER_FULFILLED:
      return {
        ...state,
        userSearchResult: action.payload,
        isSearchingUsers: false,
        hasSearchedUsers: true,
        errorSearchingUsers: null
      };

    case types.FRIENDS_SEARCH_USER_REJECTED:
      return {
        ...state,
        userSearchResult: [],
        isSearchingUsers: false,
        hasSearchedUsers: false,
        errorSearchingUsers: action.payload
      };

    case types.FRIENDS_CLEAR_SEARCH_USER:
      return {
        ...state,
        userSearchResult: [],
        isSearchingUsers: false,
        hasSearchedUsers: false,
        errorSearchingUsers: null
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/friends-reducer.js